
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// types
import { InvoiceNewServicesT } from '@/core/types/orders.types'

// constants
import {
    INVOICE_ADDITIONAL_SERVICES_EXTENDED,
    INVOICE_ADDITIONALL_SERVICES_EXTENDED_BLOCKS,
    INVOICE_ADDITIONAL_SERVICES_TMC,
} from '@/core/constants/invoices.constants'
import { tmc } from '@/core/realisations/tmc.realisation'
import { WriteOffT } from '@/core/types/tmc.types'
import { write } from 'xlsx'

export default defineComponent({
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Доп. услуги',
        },
        invoiceNumber: {
            type: String,
            defalut: null,
        },
        key: {
            type: String,
            default: 'Service',
        },
        services: {
            type: Object as PropType<InvoiceNewServicesT>,
            default: null,
        },
    },
    setup(props) {
        const state = reactive({
            is_loading: false,
            //
            write_offs: [] as WriteOffT[],
        })

        const isVisibleServiceExtended = (type_code: string) => {
            return INVOICE_ADDITIONAL_SERVICES_EXTENDED.includes(type_code)
        }

        const isVisibleServiceTMC = (type_id: number) => {
            const write_off = state.write_offs.find(
                (w_o) => w_o.additionalServiceTypeId === type_id
            )

            return (
                INVOICE_ADDITIONAL_SERVICES_TMC.includes(type_id) &&
                state.write_offs.length &&
                write_off
            )
        }

        const getAdditionalServicesTMC = async () => {
            try {
                state.is_loading = true

                const params = {
                    page: 1,
                    invoiceNumber: props.invoiceNumber as string,
                    //
                    additionalServiceTypeId: null,
                    code1C: null,
                    warehouseId: null,
                    writeOffTypeId: null,
                    inventoryItemIds: [],
                    payerCompanyIds: [],
                }

                const response = await tmc.getWriteOffs(params)
                state.write_offs = response.data
            } catch (error) {
                console.log(error)
            } finally {
                state.is_loading = false
            }
        }

        const getServiceTmc = (type_id: number, key: string) => {
            if (!state.write_offs.length) return

            const write_off = state.write_offs.find(
                (w_o) => w_o.additionalServiceTypeId === type_id
            )

            if (write_off) {
                if (key === 'link') return write_off.id
                else return write_off.totalCubature
            }

            return '-'
        }

        onBeforeMount(() => {
            if (props.invoiceNumber) getAdditionalServicesTMC()
        })

        return {
            state,
            //
            getServiceTmc,
            //
            isVisibleServiceExtended,
            isVisibleServiceTMC,
            //
            INVOICE_ADDITIONAL_SERVICES_EXTENDED,
            INVOICE_ADDITIONAL_SERVICES_TMC,
            INVOICE_ADDITIONALL_SERVICES_EXTENDED_BLOCKS,
        }
    },
})
